import axios from 'axios';

/**
 * Cliente Axios com interceptor para adicionar token JWT
 * Conforme doc 02-arquitetura-do-sistema.md
 */

// Lógica para evitar o erro de URLs duplicadas/vírgulas
const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:4231/api';
  
  // Se a URL do .env começar com "/", montamos ela dinamicamente com o domínio atual
  if (envUrl.startsWith('/')) {
    return `${window.location.origin}${envUrl}`;
  }
  
  // Caso contrário (ex: em localhost), usa a URL completa definida
  return envUrl;
};

const API_BASE_URL = getBaseUrl();

// Log da URL da API (sempre, para debug)
console.log('🔧 Ambiente:', process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development');
console.log('🌐 API URL FINAL:', API_BASE_URL);

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token em todas as requisições
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('nerdzpoker_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Debug: Log para requisições de fechar rodada
    if (config.url && config.url.includes('/fechar') && config.method === 'put') {
      console.log('🔍 [Axios Interceptor] Payload antes de enviar:', JSON.stringify(config.data, null, 2));
      console.log('🔍 [Axios Interceptor] apenas_salvar:', config.data?.apenas_salvar, typeof config.data?.apenas_salvar);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && !currentPath.startsWith('/cadastro')) {
        localStorage.removeItem('nerdzpoker_token');
        localStorage.removeItem('nerdzpoker_user');
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;